<template>
  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand bg-white navbar-light border-bottom">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a
          class="nav-link"
          data-widget="pushmenu"
          @click="openNav">
          <i class="fa fa-bars"/>
        </a>
      </li>
    </ul>
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- Messages Dropdown Menu -->
      <li class="nav-item dropdown">
        <a
          class="nav-link"
          data-toggle="dropdown"
          to="/Sample1">
          <i class="fa fa-user-circle-o "/>{{ username }}
        </a>
      </li>
      <li class="nav-item dropdown"> <a
        class="nav-link"
        data-toggle="dropdown"
        @click="logout">
        <i
          class="fa fa-sign-out "
        />

        <!-- Message End -->
      </a>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      username: localStorage.getItem('username')
    }
  },
  methods: {
    logout () {
      return this.$store.dispatch('Auth/logout', this.authInfo)
        .then(() => {
          this.$router.push({ name: 'Login' })
        })
        .catch(err => this.throwReject(err))
    },
    openNav () {
      var sidebar = document.getElementById('sidebar')
      if (sidebar.classList.contains('sidebar-collapse')) {
        sidebar.classList.replace('sidebar-collapse', 'sidebar-open')
      } else {
        sidebar.classList.replace('sidebar-open', 'sidebar-collapse')
      }
    }
  }
}
</script>

<style scoped>
.nav-item .nav-link img {
 height: 100%;
 width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/OrHeader.vue